import React from 'react';
import { AppLauncherEngine } from '../../components/workspace/AppLauncherEngine';
import { OperationsToolsRegistry } from './OperationsToolsRegistry';

export function WorkDashboard() {
  return (
    <AppLauncherEngine 
      hubId="operations" 
      hubName="Operations & Projects" 
      tools={OperationsToolsRegistry} 
    />
  );
}
